import React, { useState } from 'react'
import { CustomerDataGrid } from './CustomerDataGrid'
import {Customer, CustomersService} from "../../api";
import {TableState} from "../../components/DataGrid/types";
import {JSONToHTMLTable} from "../../components";


export const CustomersPage = (props) => {
  const [loading, setLoading] = useState<boolean>();
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [currentPageSize, setCurrentPageSize] = useState<number>(10)
  const [appliedFilters, setAppliedFilters] = useState<Customer>()
  const [numberOfRecords, setNumberOfRecords] = useState<number>(0)
  const [results, setResults] = useState<Array<Customer>>([])
  const [errors,SetError] = useState(null)
  const getCustomers = (data?:Customer) => {
    setLoading(true)
    SetError(null)
    CustomersService.customersList(
        data?.customer_type,
        data?.first_name,
        data?.last_name || undefined,
        data?.email,
        data?.contact_number,
        undefined,
        undefined,currentPage,currentPageSize
    ).then((res)=>{
       setNumberOfRecords(res.count)
       setResults(res.results)
    }).catch((res)=>{
      SetError(res)
    }).finally(()=>{
      setLoading(false)
    })
  }
  const handleTableChange = (type:string, { page, sizePerPage }:TableState) => {
    setCurrentPage(page)
    setCurrentPageSize(sizePerPage)
    getCustomers(appliedFilters)
  }
  const onFilter = (data:Customer) => {

    setCurrentPage(1)
      setAppliedFilters(data)
    getCustomers(data)
  }

  return (
    <>
      {errors && <JSONToHTMLTable data={errors}/>}
      <CustomerDataGrid
        results={results}
        page_size={currentPageSize}
        current={currentPage}
        count={numberOfRecords}
        onFilter={onFilter}
        handleTableChange={handleTableChange}
        loading={loading}
      />
    </>
  )
}
